import { render, staticRenderFns } from "./IncompatibleBrowser.vue?vue&type=template&id=2da74876"
import script from "./IncompatibleBrowser.vue?vue&type=script&lang=js"
export * from "./IncompatibleBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports